/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetEquipmentResponse } from '../model';
// @ts-ignore
import { GetEquipmentsResponse } from '../model';
// @ts-ignore
import { PostEquipmentResponse } from '../model';
// @ts-ignore
import { SearchEquipmentsResponse } from '../model';
/**
 * EquipmentsApi - axios parameter creator
 * @export
 */
export const EquipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [variableId] 
         * @param {string} [unitId] 
         * @param {string} [equipmentName] 
         * @param {number} [totalTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEquipment: async (files?: Array<any>, customerId?: string, locationId?: string, variableId?: string, unitId?: string, equipmentName?: string, totalTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/equipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (customerId !== undefined) { 
                localVarFormParams.append('customerId', customerId as any);
            }
    
            if (locationId !== undefined) { 
                localVarFormParams.append('locationId', locationId as any);
            }
    
            if (variableId !== undefined) { 
                localVarFormParams.append('variableId', variableId as any);
            }
    
            if (unitId !== undefined) { 
                localVarFormParams.append('unitId', unitId as any);
            }
    
            if (equipmentName !== undefined) { 
                localVarFormParams.append('equipmentName', equipmentName as any);
            }
    
            if (totalTime !== undefined) { 
                localVarFormParams.append('totalTime', totalTime as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEquipment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEquipment', 'id', id)
            const localVarPath = `/api/equipments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachFile: async (id: string, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadAttachFile', 'id', id)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('downloadAttachFile', 'fileName', fileName)
            const localVarPath = `/api/equipments/download/{id}/{fileName}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEquipments: async (keySearch: string, orderBy: string, orderDesc: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keySearch' is not null or undefined
            assertParamExists('exportEquipments', 'keySearch', keySearch)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('exportEquipments', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('exportEquipments', 'orderDesc', orderDesc)
            const localVarPath = `/api/equipments/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keySearch !== undefined) {
                localVarQueryParameter['keySearch'] = keySearch;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEquipment: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/equipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquipmentById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEquipmentById', 'id', id)
            const localVarPath = `/api/equipments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [variableId] 
         * @param {string} [unitId] 
         * @param {string} [equipmentName] 
         * @param {number} [totalTime] 
         * @param {boolean} [removeFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEquipment: async (id: string, files?: Array<any>, customerId?: string, locationId?: string, variableId?: string, unitId?: string, equipmentName?: string, totalTime?: number, removeFile?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putEquipment', 'id', id)
            const localVarPath = `/api/equipments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (customerId !== undefined) { 
                localVarFormParams.append('customerId', customerId as any);
            }
    
            if (locationId !== undefined) { 
                localVarFormParams.append('locationId', locationId as any);
            }
    
            if (variableId !== undefined) { 
                localVarFormParams.append('variableId', variableId as any);
            }
    
            if (unitId !== undefined) { 
                localVarFormParams.append('unitId', unitId as any);
            }
    
            if (equipmentName !== undefined) { 
                localVarFormParams.append('equipmentName', equipmentName as any);
            }
    
            if (totalTime !== undefined) { 
                localVarFormParams.append('totalTime', totalTime as any);
            }
    
            if (removeFile !== undefined) { 
                localVarFormParams.append('removeFile', removeFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOperatingTime: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetOperatingTime', 'id', id)
            const localVarPath = `/api/equipments/{id}/reset-operating-time`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEquipments: async (keySearch: string, limit: number, page: number, orderBy: string, orderDesc: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keySearch' is not null or undefined
            assertParamExists('searchEquipments', 'keySearch', keySearch)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('searchEquipments', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchEquipments', 'page', page)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('searchEquipments', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('searchEquipments', 'orderDesc', orderDesc)
            const localVarPath = `/api/equipments/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keySearch !== undefined) {
                localVarQueryParameter['keySearch'] = keySearch;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EquipmentsApi - functional programming interface
 * @export
 */
export const EquipmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EquipmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [variableId] 
         * @param {string} [unitId] 
         * @param {string} [equipmentName] 
         * @param {number} [totalTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEquipment(files?: Array<any>, customerId?: string, locationId?: string, variableId?: string, unitId?: string, equipmentName?: string, totalTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostEquipmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEquipment(files, customerId, locationId, variableId, unitId, equipmentName, totalTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEquipment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEquipment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachFile(id: string, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachFile(id, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEquipments(keySearch: string, orderBy: string, orderDesc: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchEquipmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportEquipments(keySearch, orderBy, orderDesc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEquipment(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEquipmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEquipment(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEquipmentById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEquipmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEquipmentById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [variableId] 
         * @param {string} [unitId] 
         * @param {string} [equipmentName] 
         * @param {number} [totalTime] 
         * @param {boolean} [removeFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putEquipment(id: string, files?: Array<any>, customerId?: string, locationId?: string, variableId?: string, unitId?: string, equipmentName?: string, totalTime?: number, removeFile?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putEquipment(id, files, customerId, locationId, variableId, unitId, equipmentName, totalTime, removeFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetOperatingTime(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetOperatingTime(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEquipments(keySearch: string, limit: number, page: number, orderBy: string, orderDesc: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchEquipmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEquipments(keySearch, limit, page, orderBy, orderDesc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EquipmentsApi - factory interface
 * @export
 */
export const EquipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EquipmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [variableId] 
         * @param {string} [unitId] 
         * @param {string} [equipmentName] 
         * @param {number} [totalTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEquipment(files?: Array<any>, customerId?: string, locationId?: string, variableId?: string, unitId?: string, equipmentName?: string, totalTime?: number, options?: any): AxiosPromise<PostEquipmentResponse> {
            return localVarFp.addEquipment(files, customerId, locationId, variableId, unitId, equipmentName, totalTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEquipment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEquipment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachFile(id: string, fileName: string, options?: any): AxiosPromise<void> {
            return localVarFp.downloadAttachFile(id, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEquipments(keySearch: string, orderBy: string, orderDesc: string, options?: any): AxiosPromise<SearchEquipmentsResponse> {
            return localVarFp.exportEquipments(keySearch, orderBy, orderDesc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEquipment(options?: any): AxiosPromise<GetEquipmentsResponse> {
            return localVarFp.getAllEquipment(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquipmentById(id: string, options?: any): AxiosPromise<GetEquipmentResponse> {
            return localVarFp.getEquipmentById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [variableId] 
         * @param {string} [unitId] 
         * @param {string} [equipmentName] 
         * @param {number} [totalTime] 
         * @param {boolean} [removeFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEquipment(id: string, files?: Array<any>, customerId?: string, locationId?: string, variableId?: string, unitId?: string, equipmentName?: string, totalTime?: number, removeFile?: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.putEquipment(id, files, customerId, locationId, variableId, unitId, equipmentName, totalTime, removeFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOperatingTime(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.resetOperatingTime(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEquipments(keySearch: string, limit: number, page: number, orderBy: string, orderDesc: string, options?: any): AxiosPromise<SearchEquipmentsResponse> {
            return localVarFp.searchEquipments(keySearch, limit, page, orderBy, orderDesc, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addEquipment operation in EquipmentsApi.
 * @export
 * @interface EquipmentsApiAddEquipmentRequest
 */
export interface EquipmentsApiAddEquipmentRequest {
    /**
     * 
     * @type {Array<any>}
     * @memberof EquipmentsApiAddEquipment
     */
    readonly files?: Array<any>

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiAddEquipment
     */
    readonly customerId?: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiAddEquipment
     */
    readonly locationId?: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiAddEquipment
     */
    readonly variableId?: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiAddEquipment
     */
    readonly unitId?: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiAddEquipment
     */
    readonly equipmentName?: string

    /**
     * 
     * @type {number}
     * @memberof EquipmentsApiAddEquipment
     */
    readonly totalTime?: number
}

/**
 * Request parameters for deleteEquipment operation in EquipmentsApi.
 * @export
 * @interface EquipmentsApiDeleteEquipmentRequest
 */
export interface EquipmentsApiDeleteEquipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiDeleteEquipment
     */
    readonly id: string
}

/**
 * Request parameters for downloadAttachFile operation in EquipmentsApi.
 * @export
 * @interface EquipmentsApiDownloadAttachFileRequest
 */
export interface EquipmentsApiDownloadAttachFileRequest {
    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiDownloadAttachFile
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiDownloadAttachFile
     */
    readonly fileName: string
}

/**
 * Request parameters for exportEquipments operation in EquipmentsApi.
 * @export
 * @interface EquipmentsApiExportEquipmentsRequest
 */
export interface EquipmentsApiExportEquipmentsRequest {
    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiExportEquipments
     */
    readonly keySearch: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiExportEquipments
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiExportEquipments
     */
    readonly orderDesc: string
}

/**
 * Request parameters for getEquipmentById operation in EquipmentsApi.
 * @export
 * @interface EquipmentsApiGetEquipmentByIdRequest
 */
export interface EquipmentsApiGetEquipmentByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiGetEquipmentById
     */
    readonly id: string
}

/**
 * Request parameters for putEquipment operation in EquipmentsApi.
 * @export
 * @interface EquipmentsApiPutEquipmentRequest
 */
export interface EquipmentsApiPutEquipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiPutEquipment
     */
    readonly id: string

    /**
     * 
     * @type {Array<any>}
     * @memberof EquipmentsApiPutEquipment
     */
    readonly files?: Array<any>

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiPutEquipment
     */
    readonly customerId?: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiPutEquipment
     */
    readonly locationId?: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiPutEquipment
     */
    readonly variableId?: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiPutEquipment
     */
    readonly unitId?: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiPutEquipment
     */
    readonly equipmentName?: string

    /**
     * 
     * @type {number}
     * @memberof EquipmentsApiPutEquipment
     */
    readonly totalTime?: number

    /**
     * 
     * @type {boolean}
     * @memberof EquipmentsApiPutEquipment
     */
    readonly removeFile?: boolean
}

/**
 * Request parameters for resetOperatingTime operation in EquipmentsApi.
 * @export
 * @interface EquipmentsApiResetOperatingTimeRequest
 */
export interface EquipmentsApiResetOperatingTimeRequest {
    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiResetOperatingTime
     */
    readonly id: string
}

/**
 * Request parameters for searchEquipments operation in EquipmentsApi.
 * @export
 * @interface EquipmentsApiSearchEquipmentsRequest
 */
export interface EquipmentsApiSearchEquipmentsRequest {
    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiSearchEquipments
     */
    readonly keySearch: string

    /**
     * 
     * @type {number}
     * @memberof EquipmentsApiSearchEquipments
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof EquipmentsApiSearchEquipments
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiSearchEquipments
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof EquipmentsApiSearchEquipments
     */
    readonly orderDesc: string
}

/**
 * EquipmentsApi - object-oriented interface
 * @export
 * @class EquipmentsApi
 * @extends {BaseAPI}
 */
export class EquipmentsApi extends BaseAPI {
    /**
     * 
     * @param {EquipmentsApiAddEquipmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentsApi
     */
    public addEquipment(requestParameters: EquipmentsApiAddEquipmentRequest = {}, options?: AxiosRequestConfig) {
        return EquipmentsApiFp(this.configuration).addEquipment(requestParameters.files, requestParameters.customerId, requestParameters.locationId, requestParameters.variableId, requestParameters.unitId, requestParameters.equipmentName, requestParameters.totalTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EquipmentsApiDeleteEquipmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentsApi
     */
    public deleteEquipment(requestParameters: EquipmentsApiDeleteEquipmentRequest, options?: AxiosRequestConfig) {
        return EquipmentsApiFp(this.configuration).deleteEquipment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EquipmentsApiDownloadAttachFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentsApi
     */
    public downloadAttachFile(requestParameters: EquipmentsApiDownloadAttachFileRequest, options?: AxiosRequestConfig) {
        return EquipmentsApiFp(this.configuration).downloadAttachFile(requestParameters.id, requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EquipmentsApiExportEquipmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentsApi
     */
    public exportEquipments(requestParameters: EquipmentsApiExportEquipmentsRequest, options?: AxiosRequestConfig) {
        return EquipmentsApiFp(this.configuration).exportEquipments(requestParameters.keySearch, requestParameters.orderBy, requestParameters.orderDesc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentsApi
     */
    public getAllEquipment(options?: AxiosRequestConfig) {
        return EquipmentsApiFp(this.configuration).getAllEquipment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EquipmentsApiGetEquipmentByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentsApi
     */
    public getEquipmentById(requestParameters: EquipmentsApiGetEquipmentByIdRequest, options?: AxiosRequestConfig) {
        return EquipmentsApiFp(this.configuration).getEquipmentById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EquipmentsApiPutEquipmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentsApi
     */
    public putEquipment(requestParameters: EquipmentsApiPutEquipmentRequest, options?: AxiosRequestConfig) {
        return EquipmentsApiFp(this.configuration).putEquipment(requestParameters.id, requestParameters.files, requestParameters.customerId, requestParameters.locationId, requestParameters.variableId, requestParameters.unitId, requestParameters.equipmentName, requestParameters.totalTime, requestParameters.removeFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EquipmentsApiResetOperatingTimeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentsApi
     */
    public resetOperatingTime(requestParameters: EquipmentsApiResetOperatingTimeRequest, options?: AxiosRequestConfig) {
        return EquipmentsApiFp(this.configuration).resetOperatingTime(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EquipmentsApiSearchEquipmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentsApi
     */
    public searchEquipments(requestParameters: EquipmentsApiSearchEquipmentsRequest, options?: AxiosRequestConfig) {
        return EquipmentsApiFp(this.configuration).searchEquipments(requestParameters.keySearch, requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, options).then((request) => request(this.axios, this.basePath));
    }
}
